export const DEFAULT_INTL = 'en-US'

export const SALES_TARGETS_QUERY_KEY = 'salesTargets'

export const COUNTRIES_QUERY_KEY = 'countries'
export const LANGUAGES_QUERY_KEY = 'languages'

export const OKTA_AUTH_CONFIG_KEY = 'okta-auth-config'
export const OKTA_TOKEN_STORAGE_KEY = 'okta-token-storage'
export const SALES_TARGETS_ACTIVITIES_QUERY_KEY = 'salesTargetsActivities'
export const TEXT_TAG_ACTIVATION_CHAR = '$'
export const SALES_TARGET_MAIN_GROUP = [
  'Main Target',
  'Product Target',
  'Product Target - Layered',
  'Monthly Target - Layered',
]
export const SALES_TARGET_PREREQUISITE_GROUP = ['Monthly Prerequisite Target', 'Product Target - Prerequisite']

export const UPLOAD_HISTORY_TYPE = {
  PRODUCT: 'PRODUCT',
  INVENTORY: 'INVENTORY'
}
export const PRODUCT_TYPE = {
  BRAND: 'brand',
  SUBBRAND  : 'subbrand',
  DISPLAYBRAND: 'displaybrand',
  CATEGORY  : 'category',
  SUBCATEGORY  : 'subCategory',
  DISPLAYCATEGORY: 'displaycategory',
  PRODUCT: 'product',
}
